export default {
    props: {
        value: {},
    },
    data: () => ({
        selectedMethod: null,
    }),
    watch: {
        selectedMethod(value) {
            if (value) {
                this.$emit('input', value);
            }
        },
        value(value) {
            if (value !== this.selectedMethod) {
                this.selectedMethod = null;
            }
        },
    },
};